import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
});

// Attach JWT on every request
api.interceptors.request.use(cfg => {
  const token = localStorage.getItem('vg_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// On 401 → redirect to login
api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('vg_token');
      localStorage.removeItem('vg_user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
